/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudHospitality = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10.357 7.194A4.974 4.974 0 0 1 15 4a5 5 0 0 1 4.996 4.802A5.995 5.995 0 0 1 23 14c0 1.471-.6 2.913-1.474 3.988-.86 1.058-2.118 1.912-3.526 1.912v-2c.592 0 1.334-.387 1.974-1.174C20.601 15.955 21 14.947 21 14a4 4 0 0 0-2.433-3.68l-.674-.288.072-.73.015-.132.006-.044A4.875 4.875 0 0 0 18 9a3 3 0 0 0-3-3 2.988 2.988 0 0 0-2.964 2.684l-.165 1.556-1.343-.804A2.956 2.956 0 0 0 9 9a3 3 0 0 0-3 3v1.535l-.445.297c-1.236.824-1.885 2.08-2.222 3.205-.105.35-.177.678-.226.963H7v2H1v-1h1-1v-.023a3.711 3.711 0 0 1 .007-.204 10.325 10.325 0 0 1 .41-2.31C1.793 15.208 2.535 13.648 4 12.49V12a5 5 0 0 1 5-5c.474 0 .929.07 1.357.194zm1.143 6.917A4.502 4.502 0 0 0 8 18.5V21h9v-2.5a4.502 4.502 0 0 0-3.5-4.389V13h-2v1.111zm1 1.889a2.5 2.5 0 0 1 2.5 2.5v.5h-5v-.5a2.5 2.5 0 0 1 2.5-2.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCloudHospitality as CloudHospitality };
